(() => {
  function initialize(root = document) {
    function showProductImage(gallery, id) {
      if (!gallery || !id || !gallery.querySelector(`[data-gallery-image="${id}"]`)) return;
      gallery.querySelectorAll('[data-gallery-image]').forEach(image => { image.hidden = image.dataset.galleryImage !== String(id); });
      gallery.querySelectorAll('[data-gallery-target]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === String(id))); });
    }
    root.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = 'true';
      gallery.querySelectorAll('[data-gallery-target]').forEach(button => {
        button.addEventListener('click', () => showProductImage(gallery, button.dataset.galleryTarget));
      });
    });
    root.querySelectorAll('[data-product-options]').forEach(options => {
      if (options.dataset.bound) return;
      options.dataset.bound = 'true';
      const variants = JSON.parse(options.querySelector('[data-product-variants]').textContent);
      const groups = Array.from(options.querySelectorAll('[data-option-position]'));
      options.querySelectorAll('input[type=radio]').forEach(radio => { radio.required = true; });
      const input = options.querySelector('[data-resolved-variant]');
      const purchase = options.closest('.product-purchase');
      const form = options.closest('form');
      const submit = form.querySelector('[data-product-submit]');
      const gallery = purchase.closest('.product-page-grid').querySelector('[data-product-gallery]');
      function update() {
        const selected = groups.map(group => group.querySelector('input:checked')?.value);
        const complete = selected.every(Boolean);
        const matching = variants.filter(variant => selected.every((value, index) => !value || variant.options[index] === value));
        const variant = complete ? matching[0] : null;
        input.value = variant ? String(variant.id) : '';
        input.disabled = !variant || !variant.available;
        if (submit) {
          submit.disabled = complete ? !variant?.available : !matching.some(item => item.available);
          submit.textContent = submit.disabled ? submit.dataset.unavailableLabel : submit.dataset.addLabel;
        }
        const displayVariant = variant || matching.find(item => item.available) || matching[0];
        if (displayVariant) {
          const template = document.getElementById(`ProductPrice-${displayVariant.id}`);
          if (template) purchase.querySelector('[data-product-price]').replaceChildren(template.content.cloneNode(true));
          showProductImage(gallery, displayVariant.featured_image?.id);
        }
        const url = new URL(window.location.href);
        if (variant) url.searchParams.set('variant', variant.id);
        else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
      }
      options.addEventListener('change', update);
      form.addEventListener('submit', event => {
        if (input.disabled) { event.preventDefault(); form.reportValidity(); }
      });
      update();
    });
    root.querySelectorAll('[data-open-dialog]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.openDialog);
        if (dialog) dialog.showModal();
      });
    });
    root.querySelectorAll('dialog').forEach(dialog => {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = 'true';
      dialog.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
    });
    root.querySelectorAll('[data-copy-code]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', async () => {
        const status = button.closest('.offer-ticket').querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(button.dataset.copyCode);
          status.textContent = button.dataset.copied;
        } catch {
          status.textContent = button.dataset.copyFailed;
        }
      });
    });
    root.querySelectorAll('.mobile-menu a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
    root.querySelectorAll('[data-price-template]').forEach(input => {
      if (input.dataset.priceBound) return;
      input.dataset.priceBound = 'true';
      input.addEventListener('change', () => {
        const template = document.getElementById(input.dataset.priceTemplate);
        const output = input.closest('dialog, .product-purchase')?.querySelector('[data-variant-price]');
        if (template && output) output.replaceChildren(template.content.cloneNode(true));
      });
    });
    root.querySelectorAll('[data-product-price-template]').forEach(input => {
      if (input.dataset.bound) return;
      input.dataset.bound = 'true';
      input.addEventListener('change', () => {
        const template = document.getElementById(input.dataset.productPriceTemplate);
        const output = input.closest('.product-purchase')?.querySelector('[data-product-price]');
        if (template && output) output.replaceChildren(template.content.cloneNode(true));
        if (input.checked && input.name === 'id') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url);
        }
      });
    });
    root.querySelectorAll('[data-quantity-control]').forEach(control => {
      if (control.dataset.bound) return;
      control.dataset.bound = 'true';
      const input = control.querySelector('input');
      const decrease = control.querySelector('[data-quantity-step="-1"]');
      function normalize() {
        const number = Number(input.value);
        input.value = Number.isFinite(number) ? Math.max(1, Math.floor(number)) : 1;
        decrease.disabled = Number(input.value) <= 1;
      }
      control.querySelectorAll('[data-quantity-step]').forEach(button => {
        button.addEventListener('click', () => {
          normalize();
          input.value = Math.max(1, Number(input.value) + Number(button.dataset.quantityStep));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      input.addEventListener('change', normalize);
      input.addEventListener('blur', normalize);
      input.addEventListener('input', () => { decrease.disabled = !input.value || Number(input.value) <= 1; });
      normalize();
    });
    const form = root.querySelector('[data-cart-form]');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = 'true';
    const name = form.querySelector('[data-athlete-name]');
    const team = form.querySelector('[data-athlete-team]');
    const status = form.querySelector('[data-athlete-status]');
    if (!name || !team || !status) return;
    const allowedTeams = new Set(Array.from(team.options, option => option.value).filter(Boolean));
    let pending = Promise.resolve();
    let busy = false;
    function validate() {
      name.value = name.value.trim();
      name.setCustomValidity(name.value ? '' : name.dataset.error);
      team.setCustomValidity(allowedTeams.has(team.value) ? '' : team.dataset.error);
      return form.reportValidity();
    }
    function save(extra = {}) {
      const attributes = { 'Athlete name': name.value.trim(), Team: team.value };
      const operation = pending.catch(() => {}).then(async () => {
        const response = await fetch(form.dataset.updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes, ...extra })
        });
        if (!response.ok) throw new Error('Cart save failed');
        const cart = await response.json();
        if ((cart.attributes?.['Athlete name'] || '') !== attributes['Athlete name'] || (cart.attributes?.Team || '') !== attributes.Team) throw new Error('Cart attributes not confirmed');
        return cart;
      });
      pending = operation;
      return operation;
    }
    name.addEventListener('input', () => name.setCustomValidity(''));
    team.addEventListener('change', () => team.setCustomValidity(''));
    [name, team].forEach(input => input.addEventListener('change', async () => {
      if (team.value && !allowedTeams.has(team.value)) return;
      status.textContent = form.dataset.saving;
      try { await save(); status.textContent = form.dataset.saved; }
      catch { status.textContent = form.dataset.saveFailed; }
    }));
    async function submitCart(event) {
      event.preventDefault();
      if (busy) return;
      const submitter = event.submitter || event.currentTarget;
      if (submitter?.disabled) return;
      const isCheckout = submitter?.name === 'checkout';
      const isUpdate = submitter?.hasAttribute('data-update-cart') || submitter?.hasAttribute('data-remove-key');
      if (!isUpdate && !validate()) return;
      if (isUpdate && !Array.from(form.querySelectorAll('[data-line-key]')).every(input => input.reportValidity())) return;
      const updates = {};
      form.querySelectorAll('[data-line-key]').forEach(input => { updates[input.dataset.lineKey] = Number(input.value); });
      if (submitter?.dataset.removeKey) updates[submitter.dataset.removeKey] = 0;
      busy = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = form.dataset.saving;
      try {
        await save(isCheckout || isUpdate ? { updates } : {});
        status.textContent = form.dataset.saved;
        if (isCheckout) {
          const checkoutField = document.createElement('input');
          checkoutField.type = 'hidden'; checkoutField.name = 'checkout'; checkoutField.value = 'Checkout';
          form.appendChild(checkoutField);
          HTMLFormElement.prototype.submit.call(form);
        } else if (isUpdate) window.location.reload();
      } catch {
        status.textContent = form.dataset.saveFailed;
        status.focus();
      } finally {
        busy = false;
        form.removeAttribute('aria-busy');
      }
    }
    form.addEventListener('submit', submitCart);
    form.querySelectorAll('a[data-remove-key]').forEach(link => link.addEventListener('click', submitCart));
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
